import {ProgressBarResponse} from "../../api/ProgressApi";

export const ProgressSourceSymbol = Symbol.for('ProgressSourceSymbol');

export interface IProgressSourceAdapter {
    getProgressBar(courseId: number): Promise<ProgressBarResponse>;
}
